import { render, staticRenderFns } from "./fixed-duration.vue?vue&type=template&id=b54be73a&scoped=true"
import script from "./fixed-duration.vue?vue&type=script&lang=js"
export * from "./fixed-duration.vue?vue&type=script&lang=js"
import style0 from "./fixed-duration.vue?vue&type=style&index=0&id=b54be73a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54be73a",
  null
  
)

export default component.exports